import { useState, useEffect, useCallback } from "react";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import debounce from "lodash.debounce";

import useHelpers from "../../../../helpers";
import useApi from "../../../../api";

const useSettingsView = () => {
  const [listSettings, setListSettings] = useState([]);
  const [modalDelete, setModalDelete] = useState({ show: false, name: "", id: "" });
  const [searchText, setSearchText] = useState("");
  const [paginationSettings, setPaginationSettings] = useState({ current: 1, totalPages: 1 });
  const navigation = useNavigate();

  const { useActions } = useApi();
  const { useSettingsActions } = useActions();
  const { actListSettings, actDeleteSetting } = useSettingsActions();

  const { useQuickFunctions, useSettingsSecrets } = useHelpers();
  const { useToast } = useQuickFunctions();
  const { success } = useToast();
  const { isSecretKey } = useSettingsSecrets();

  const { control } = useForm({
    mode: "all",
  });

  const loadData = (data) => {
    setListSettings(data.data);
    setPaginationSettings({
      current: data.meta.current_page,
      totalPages: data.meta.last_page
    });
  };

  const loadDataPagination = (data) => {
    setListSettings(data.data);
  };

  const handleCreateNewSetting = () => {
    navigation("/configuracion/settings/creacion");
  };

  const handleEditSetting = (setting) => {
    navigation(`/configuracion/settings/editar/${setting.id}`);
  };

  const handleCloseModal = () => {
    setModalDelete({ show: false, name: "", id: "" });
  };

  const handleRemoveSetting = (id, name) => {
    setModalDelete({ show: true, name: name, id: id });
  };

  const handleConfirmDelete = () => {
    actDeleteSetting(modalDelete.id, onSubmitSuccess);
    setModalDelete({ show: false, name: "", id: "" });
  };

  const onSubmitSuccess = () => {
    success("Configuración eliminada con éxito!");
    setTimeout(() => {
      actListSettings({ page: 1, page_size: 10 }, loadData);
    }, 1000);
  };

  const handlePagination = (nro) => {
    setPaginationSettings({ ...paginationSettings, current: nro.selected + 1 });
    actListSettings({ page: nro.selected + 1, page_size: 10, search: searchText }, loadDataPagination);
  };

  const onSubmitSearch = (e) => {
    setSearchText(e);
    actListSettings({ page: 1, page_size: 10, search: e }, loadData);
  };

  const onChangeSearch = useCallback(debounce(onSubmitSearch, 750), []);

  const formatContent = (content, id) => {
    // Los secretos ya llegan enmascarados del backend (p.ej. ••••1234); se
    // muestran tal cual. Para el resto se formatea el valor legible.
    if (isSecretKey(id)) {
      return content;
    }
    try {
      const parsed = JSON.parse(content);
      if (typeof parsed === "object") {
        return JSON.stringify(parsed);
      }
      return String(parsed);
    } catch {
      return content;
    }
  };

  useEffect(() => {
    actListSettings({ page: 1, page_size: 10 }, loadData);
  }, []);

  return {
    control,
    listSettings,
    handleCreateNewSetting,
    handleEditSetting,
    handleRemoveSetting,
    handleCloseModal,
    handleConfirmDelete,
    paginationSettings,
    handlePagination,
    onChangeSearch,
    modalDelete,
    formatContent,
  };
};

export default useSettingsView;
